module.exports = __webpack_public_path__ + "img/Man.9418bf91.png";